import React, { Component } from 'react';
import { bool, func, shape } from 'prop-types';
import { connect } from 'react-redux';

import { closeRightSidePanel } from 'reducers/compModels/sidePanel';
import ReaderViews from './views';
import {
  createHighlight,
  extractAndModifyUrl,
  resetAnnotation,
  resetNotebook,
  saveMobileSetting
} from 'PipeRouter';

class Reader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeMenu: 'E-book'
    };

    this.props.extractAndModifyUrl();
    this.props.saveMobileSetting();
  }

  toggle = (selection) => {
    const { notifications, resetAnnotation, resetNotebook } = this.props;
    const { activeMenu } = this.state;

    if (notifications.createPageViewerFail || notifications.isLoading) {
      return;
    }

    if (selection === activeMenu) {
      return;
    }

    if (selection === 'NOTEBOOK') {
      // this.props.closeRightSidePanel();
      resetAnnotation();
    }
    if (selection === 'E-book') {
      resetNotebook();
    }

    this.setState({
      activeMenu: selection
    });
  }

  render() {
    const {
      notifications: { createPageViewerFail, isLoading },
      showPageSelector
    } = this.props;

    const viewProps = {
      createPageViewerFail,
      isLoading,
      activeMenu: this.state.activeMenu,
      toggle: this.toggle,
      showPageSelector
    };

    return <ReaderViews { ...viewProps } />;
  }
}

Reader.propTypes = {
  extractAndModifyUrl: func,
  notifications: shape({
    createPageViewerFail: bool,
    isLoading: bool
  }),
  resetAnnotation: func,
  showPageSelector: bool
};


function mapStateToProps(state) {
  const { annotation, notifications, reader, selectedHighlight } = state;

  return {
    annotation,
    notifications,
    showPageSelector: reader.showPageSelector,
    isMobile: reader.isMobile,
    selectedHighlight
  };
}

export default connect(mapStateToProps, {
  closeRightSidePanel,
  extractAndModifyUrl,
  resetAnnotation,
  resetNotebook,
  saveMobileSetting,
  createHighlight
})(Reader);
